import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonServices } from '../services/commonServices';
const commonServices = new CommonServices();

import { Loadingfuction } from '../store/reducers/loading.reducer';

interface VerifyProps {}
const VerifyPage: React.FC<VerifyProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [errorMessage, seterrorMessage] = useState('');

  useEffect(() => {
    if (window.location.pathname.includes('/error')) {
      const params = new URLSearchParams(window.location.search);
      const message = params.get('message');
      if (message) {
        seterrorMessage(
          decodeURIComponent(message?.replace(/"/g, '')) ||
            'Something Went Wrong. Please Try Again'
        );
      } else {
        seterrorMessage('Something Went Wrong. Please Try Again');
      }
    } else if (window.location.pathname.includes('/invalid_token')) {
      seterrorMessage('Invalid Token URL, Please try again');
    } else {
      seterrorMessage('Invalid URL, Please try again');
    }
  }, []);

  return (
    <div className='d-flex align-items-center justify-content-center vh-75'>
      <span className='fw-medium bg-error-text error-text p-2 rounded-2 mx-2 text_subheding_bold'>
        {errorMessage}
      </span>
    </div>
  );
};
export default VerifyPage;
